import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
export var methods = {
  redirect: function redirect() {
    var that = this;

    if (this.domains.length) {
      for (var i = 0; i < that.domains.length; i++) {
        that.$request(that.domains[i]).then(function () {
          that.reqFlag++;

          if (that.reqFlag === that.domains.length) {
            if (!that.wudomain) {
              window.location.href = decodeURIComponent(that.$utils.uniteProtocol(that.url));
            } else {
              window.location.href = decodeURIComponent(that.wudomain).split(',')[0].split('/cas/')[0] + '/blankpage/blank.html?jumpUrl=' + that.url + '&' + 'reqUrl=' + that.wudomain;
            }
          }
        }).catch(function () {
          that.reqFlag++;

          if (that.reqFlag === that.domains.length) {
            if (!that.wudomain) {
              window.location.href = decodeURIComponent(that.$utils.uniteProtocol(that.url));
            } else {
              window.location.href = decodeURIComponent(that.wudomain).split(',')[0].split('/cas/')[0] + '/blankpage/blank.html?jumpUrl=' + that.url + '&' + 'reqUrl=' + that.wudomain;
            }
          }
        });
      }
    } else {
      if (!that.wudomain) {
        window.location.href = decodeURIComponent(that.$utils.uniteProtocol(that.url));
      } else {
        window.location.href = decodeURIComponent(that.wudomain).split(',')[0].split('/cas/')[0] + '/blankpage/blank.html?jumpUrl=' + that.url + '&' + 'reqUrl=' + that.wudomain;
      }
    }
  }
};